import Model from '../models/agence.model'
import AgenceRole from '../models/role.model'

export default {
  edit: ({ PUT }, model) =>
    new Promise((resolve, reject) => {
      if (!(model instanceof Model)) {
        return reject(
          new Error(
            `Erreur paramètre : ${Model.constructor.name} attendu mais reçu "${model.constructor.name}"`
          )
        )
      } else if (model.isNew()) {
        return reject(
          new Error(`Erreur paramètre : ${Model.constructor.name} is new`)
        )
      }

      return PUT(`agences/${model.getId()}`, model)
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new Model(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
  editCollaborateur: ({ PUT }, model) =>
    new Promise((resolve, reject) => {
      if (!(model instanceof AgenceRole)) {
        return reject(
          new Error(
            `Erreur paramètre : ${AgenceRole.constructor.name} attendu mais reçu "${model.constructor.name}"`
          )
        )
      } else if (model.isNew()) {
        return reject(
          new Error(`Erreur paramètre : ${AgenceRole.constructor.name} is new`)
        )
      }

      return PUT(
        `agences/${model.getProperty(
          'agenceId'
        )}/collaborateurs/${model.getProperty('collaborateurId')}`,
        model
      )
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new AgenceRole(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
